// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dialog-avg-on-time_avatar_KpCcr"};